import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { paymentMethod } from '@/mocks/pricingData';

export default function PaymentMethod() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('pricing.payment.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('pricing.payment.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {paymentMethod.titleEn}
          </p>
          <div className="gold-line mx-auto"></div>
        </div>

        <p className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-10 text-center max-w-[650px] mx-auto">
          {lang === 'en' ? t('pricing.paymentMethod.lead') : paymentMethod.lead}
        </p>

        <div className="border-2 border-background-200 bg-background-100/50 p-6 md:p-8 max-w-[600px] mx-auto mb-8">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-background-200/70">
            <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
              <i className="ri-bank-line text-accent-500 text-base"></i>
            </div>
            <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.06em]">
              {t('pricing.payment.bankTitle')}
            </h3>
          </div>

          <div className="p-4 bg-background-50 border border-background-200/60 mb-4">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-accent-500 text-sm"></i>
              </div>
              <div>
                {String(t('pricing.payment.bankInfo1')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-800 tracking-[0.04em] leading-relaxed">{__s}</p>))}
                {String(t('pricing.payment.bankInfo2')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-800 tracking-[0.04em] leading-relaxed mt-2 font-medium">{__s}</p>))}
              </div>
            </div>
          </div>

          <dl className="space-y-3">
            <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 pt-3 border-t border-background-200/60">
              <dt className="text-[14px] text-foreground-500 tracking-[0.04em] w-[120px] flex-shrink-0">
                {t('pricing.payment.deadlineLabel')}
              </dt>
              <dd className="text-[15px] text-foreground-800 tracking-[0.04em] font-medium">
                {lang === 'en' ? t('pricing.paymentMethod.deadline') : paymentMethod.deadline}
              </dd>
            </div>
          </dl>
        </div>

        <div className="max-w-[600px] mx-auto space-y-2">
          {paymentMethod.notes.map((note, idx) => (
            <p key={idx} className="text-[13px] text-foreground-500 tracking-[0.03em] flex items-start gap-2">
              <span className="text-accent-500 flex-shrink-0 mt-0.5">※</span>
              {lang === 'en' ? t(`pricing.paymentMethod.note.${idx}`) : note}
            </p>
          ))}
        </div>

        <div className="mt-8 max-w-[600px] mx-auto p-4 border border-background-200/60 bg-background-100/40">
          <div className="flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-error-warning-line text-accent-500 text-sm"></i>
            </div>
            {String(t('pricing.payment.warningNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.03em] leading-relaxed">{__s}</p>))}
          </div>
        </div>
      </div>
    </section>
  );
}
